import React, { useEffect } from "react";
import { Alert, GlobalStyles, Layout } from "@pankod/refine-mui";
import { useIsReadOnly } from "hooks/useIsReadOnly";

export const AppLayout: React.FC<any> = (props) => {
  return (
    <>
      <ReadOnlyMode />
      <Layout {...props} />
    </>
  );
};

const WRITE_LABELS = [
  "guardar",
  "save",
  "actualizar",
  "agregar",
  "agregar piezas",
  "agregar otro",
  "eliminar",
  "delete",
  "borrar",
  "crear",
  "create",
];

const hideWriteButtons = () => {
  document.querySelectorAll("button").forEach((button) => {
    const text = button.textContent?.trim().toLowerCase() || "";
    if (
      WRITE_LABELS.some(
        (label) => text === label || text.startsWith(`${label} `)
      )
    ) {
      button.style.display = "none";
    }
  });
};

const ReadOnlyMode = () => {
  const { isReader, isFormPage } = useIsReadOnly();

  useEffect(() => {
    document.body.classList.toggle("read-only-page", isReader);

    if (!isReader) {
      return;
    }

    hideWriteButtons();
    const observer = new MutationObserver(hideWriteButtons);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      document.body.classList.remove("read-only-page");
      observer.disconnect();
    };
  }, [isReader]);

  if (!isReader) {
    return null;
  }

  return (
    <>
      <GlobalStyles
        styles={{
          ".MuiDialog-root .MuiButton-containedPrimary, .MuiDialog-root button[type='submit']":
            {
              display: "none !important",
            },
          ".MuiDialog-root .MuiDataGrid-columnHeader[data-field='actions'], .MuiDialog-root .MuiDataGrid-cell[data-field='actions']":
            {
              display: "none !important",
            },
          ...(isFormPage
            ? {
                ".MuiCardActions-root": {
                  display: "none !important",
                },
                ".MuiDataGrid-columnHeader[data-field='actions'], .MuiDataGrid-cell[data-field='actions']":
                  {
                    display: "none !important",
                  },
                ".MuiCardContent-root .MuiInputBase-root, .MuiCardContent-root .MuiAutocomplete-root, .MuiDialog-root .MuiInputBase-root, .MuiDialog-root .MuiAutocomplete-root":
                  {
                    pointerEvents: "none",
                  },
                ".MuiCardContent-root .MuiCheckbox-root, .MuiDialog-root .MuiCheckbox-root, .MuiSwitch-root, .MuiDialog-root .MuiSwitch-root":
                  {
                    pointerEvents: "none",
                  },
              }
            : {
                ".MuiDialog-root .MuiInputBase-root, .MuiDialog-root .MuiAutocomplete-root, .MuiDialog-root .MuiCheckbox-root, .MuiDialog-root .MuiSwitch-root":
                  {
                    pointerEvents: "none",
                  },
              }),
        }}
      />
      {isFormPage && (
        <Alert
          severity="info"
          sx={{
            position: "fixed",
            top: 16,
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 1400,
            boxShadow: 2,
            maxWidth: 560,
          }}
        >
          Modo solo lectura: puedes consultar la información, pero no
          modificarla.
        </Alert>
      )}
    </>
  );
};
